<template>
  <div class="footer">
    <p>
      7x24小时服务热线：400-8788-100 | <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案：鄂ICP备17019444号-16</a> | 梧桐树保险经纪有限公司 Copyright
      ©2018版权所有
      <!-- <a
              href="https://www.wts999.com/r/cms/www/default/images/ywxk.jpg"
              target="_blank"
          >保险业务经营许可证：260580000000800</a> 保险产品和保险服务由梧桐树保险经纪有限公司提供 -->
      <!-- <a
              href="https://www.wts999.com/r/cms/www/default/images/dxzz.jpg"
              target="_blank"
          >电信增值业务经营许可证：鄂B2-20170167</a> -->
      <!-- ICP备案：鄂ICP备17019444号-16 -->
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010302001803"
        target="_blank"
      >
        <img
          src="@static/images/govIcon1.png"
          alt
          style="width: 16px"
        />鄂公网安备 42010302001803号
      </a>
      <a
        href="http://whgswj.whhd.gov.cn:8089/whwjww/indexquery/indexqueryAction!dizview.dhtml?chr_id=c1789d04a42296813c37f12aadec850e&bus_ent_id=160000003427895381&bus_ent_chr_id=0a9427982e434f21ae5ba3a4d23b3650"
        target="_blank"
      >
        <img src="@static/images/govIcon.gif" alt style="width: 16px" />工商网监
      </a>
    </p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px 60px 15px 240px;
  font-size: 12px;
  text-align: center;
  color: #ccc;

  p {
    line-height: 30px;
  }

  a {
    color: inherit;
  }
}
</style>
